<template>
  <tr class="row-item--placeholder">
    <td v-for="index in columnsLength" :key="index"><div></div></td>
  </tr>
</template>
<script>
export default {
  props: {
    columnsLength: {
      type: Number,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
@keyframes loader {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
  100% {
    opacity: 1;
  }
}

.row-item--placeholder {
  position: relative;

  td {
    padding: var(--gl-spacing-04) var(--gl-spacing-06);
    > div {
      opacity: 1;
      background: var(--gl-color-shades-gray-10);
      height: 24px;
      animation: loader 1s infinite;
    }
  }
}
</style>
